import ApiService from "../api";

export default class MotoristaService extends ApiService {

    constructor() {
        super('/api/drivers')
    }

    findAll() {
        return this.get(`?size=1000`)
    }

    update(dto) {
        return this.put(`/${dto.id}`, dto)
    }

    ajustarMotorista() {
        return this.put(`/ajustar-motoristas`)
    }
    
}